module.exports = __webpack_public_path__ + "img/car-rear.0c293809.svg";